<template>
  <ion-page>
    <main-header :back-href="backHref"></main-header>
    <ion-content padding>
      <add-stripe-card @complete="handleStripeAdded()"></add-stripe-card>
    </ion-content>
  </ion-page>
</template>

<script>
import AddStripeCard from "@/components/App/AddStripeCard";

export default {
  title: "Add Card",

  components: {
    "add-stripe-card": AddStripeCard
  },

  methods: {
    handleStripeAdded() {
      this.$router.push({ name: "App: Payment Methods" }).catch(e => e);
    }
  },

  computed: {
    backHref() {
      return this.$router.resolve({
        name: "App: Payment Methods"
      }).href;
    }
  }
};
</script>
